import { ColliStateBadge } from '@frontend/colli/common';
import { Colli } from '@frontend/colli/types';
import { DefaultBadge } from '@frontend/components/badge';
import { TransactionStateBadge, getTransactionStatusDisplay } from '@frontend/transaction/common';
import { ExtendedPudoTransaction } from '@frontend/transaction/types';
import { FormattedMessage } from 'react-intl';

export interface TransactionStatusCellProps {
    transaction: Pick<ExtendedPudoTransaction, 'state' | 'collis'>;
    /** Prefer over transaction.collis when collis are loaded separately (e.g. detail modal). */
    collis?: Colli[] | null;
}

export const TransactionStatusCell = (props: TransactionStatusCellProps) => {
    const display = getTransactionStatusDisplay(props.collis ?? props.transaction.collis, props.transaction.state);

    switch (display.type) {
        case 'transaction':
            return <TransactionStateBadge state={display.state} />;
        case 'colli':
            return <ColliStateBadge state={display.state} />;
        case 'mixed':
            return (
                <DefaultBadge
                    label={
                        <FormattedMessage
                            id='pudo.transactions.status.multiple-states'
                            description='Badge label when parcels in a transaction are in different states or locations'
                            defaultMessage='Multiple states'
                        />
                    }
                    styles={{ container: { color: 'bg-status-warning' } }}
                />
            );
    }
};

export const renderTransactionStatusCell = (obj: { row: { original: ExtendedPudoTransaction } }) => (
    <td
        key={obj.row.original.id}
        className='text-foreground-default truncate p-2 text-sm font-medium'>
        <TransactionStatusCell transaction={obj.row.original} />
    </td>
);
